/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPenaltiesQuery } from '../../models/get-penalties-query';
import { GetPenaltiesQueryResult } from '../../models/get-penalties-query-result';

export interface ApiPenaltiesGetPenaltiesPost$Params {
      body?: GetPenaltiesQuery
}

export function apiPenaltiesGetPenaltiesPost(http: HttpClient, rootUrl: string, params?: ApiPenaltiesGetPenaltiesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPenaltiesQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltiesGetPenaltiesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPenaltiesQueryResult>;
    })
  );
}

apiPenaltiesGetPenaltiesPost.PATH = '/api/Penalties/GetPenalties';
